import axios from 'axios';

export default {
  async openSync(syncId) {
    return await axios.patch(`factory_api_sync_module/${syncId}/sync/open`);
  },
}